import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { FMessage } from '../../hoc/IntlComponents';
import WarningBlock from './WarningBlock';
import { STATIC_PATH } from '../../config';
import { AttensionBlock } from './AttensionBlock';

const LandingApiRequestsGuide = ({ profile: { language } }) => (
  <div className="guide">
    <h6>
      <b>
        <FMessage id="transfer-by-api.nav.landing.guide.title" />
      </b>
    </h6>
    <WarningBlock />
    <AttensionBlock />
    <br />
    <p className="guide-questions-header">
      <FMessage id="transfer-by-api.nav.landing.guide.question" />
    </p>
    <ol>
      <li>
        <p className="question-header">
          <FMessage id="transfer-by-api.nav.landing.guide.question.1.title" />
        </p>
        <div className="question-content">
          <p>
            <FMessage id="transfer-by-api.nav.landing.guide.question.1.p-1" />
          </p>
          <div className="transfer-img">
            <img src={`${STATIC_PATH}/img/transfer-by-api/img1.png`} />
          </div>
          <p>
            <FMessage id="transfer-by-api.nav.landing.guide.question.1.p-2" />
          </p>
          <div className="transfer-img">
            <img src={`${STATIC_PATH}/img/transfer-by-api/img2${language}.png`} />
          </div>
          <p>
            <FMessage id="transfer-by-api.nav.landing.guide.question.1.p-3" />
          </p>
          <div className="transfer-img">
            <img src={`${STATIC_PATH}/img/transfer-by-api/img3${language}.png`} />
          </div>
          <p>
            <FMessage id="transfer-by-api.nav.landing.guide.question.1.p-4" />
          </p>
        </div>
      </li>
      <li>
        <p className="question-header">
          <FMessage id="transfer-by-api.nav.landing.guide.question.2.title" />
        </p>
        <div className="question-content">
          <p>
            <FMessage id="transfer-by-api.nav.landing.guide.question.2.p-1" />
          </p>
          <div className="transfer-img">
            <img src={`${STATIC_PATH}/img/transfer-by-api/img4${language}.png`} />
          </div>
          <p>
            <FMessage id="transfer-by-api.nav.landing.guide.question.2.p-2" />
          </p>
          <div className="transfer-img">
            <img src={`${STATIC_PATH}/img/transfer-by-api/img5.png`} />
          </div>
          <p>
            <FMessage id="transfer-by-api.nav.landing.guide.question.2.p-3" />
          </p>
        </div>
      </li>
      <p className="warning-wrapper no-margin">
        <FMessage id="transfer-by-api.guide.more-info-1" />
        <Link to="/faq/tools/integrations/setup/api">
          <FMessage id="transfer-by-api.guide.more-info-2" />
        </Link>
        .
      </p>
    </ol>
  </div>
);

const mapStateToProps = ({ webmaster: { profile } }) => ({
  profile,
});

export default connect(mapStateToProps)(LandingApiRequestsGuide);
